import React from 'react';

export const ProgressCircle = ({ progress, count }) => {
  return (
    <>
      <div
        id="controls-progresscircle-wrapper"
        data-testid="controls-progresscircle-wrapper"
        className="circle"
        data-progress="60"
        style={{ '--progress': progress * (360 / 100) + 'deg' } as React.CSSProperties}
      >
        {count > 0 && (
          <svg
            id="controls-progresscircle-svg-badge"
            data-testid="controls-progresscircle-svg-badge"
            className="cirlce_badge"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              id="controls-progresscircle-circle-dimensions"
              data-testid="controls-progresscircle-circle-dimensions"
              cx="8"
              cy="8"
              r="8"
              fill="#E14B53"
            />
            <text
              id="controls-progresscircle-text-detail"
              data-testid="controls-progresscircle-text-detail"
              x="50%"
              y="50%"
              textAnchor="middle"
              stroke="#FFF"
              strokeWidth="1px"
              dy=".3em"
              style={{ fontSize: '12px' }}
            >
              {count <= 9 && count}
            </text>
          </svg>
        )}
      </div>
    </>
  );
};
